/* 2026-09-20: keep the header cart-count badge in sync after AJAX add/change (the app-provided cart drawer does not update it). */
(function () {
  'use strict';
  if (window.__swwCartBadgeSync) return;
  window.__swwCartBadgeSync = true;
  var nativeFetch = window.fetch;
  if (typeof nativeFetch !== 'function') return;
  function refreshCartBadge() {
    nativeFetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (cart) {
      var link = document.getElementById('cart-icon-bubble');
      if (!link) return;
      var badge = link.querySelector('.site-header__cart-count');
      if (cart.item_count > 0) {
        if (!badge) {
          badge = document.createElement('span');
          badge.className = 'site-header__cart-count';
          badge.setAttribute('aria-hidden', 'true');
          link.appendChild(badge);
        }
        badge.textContent = cart.item_count;
      } else if (badge) {
        badge.parentNode.removeChild(badge);
      }
    }).catch(function () {});
  }
  window.fetch = function () {
    var args = arguments;
    var url = '';
    try { url = typeof args[0] === 'string' ? args[0] : (args[0] && args[0].url) || ''; } catch (e) {}
    var result = nativeFetch.apply(this, args);
    if (/\/cart\/(add|change|update|clear)(\.js)?(\?|$)/.test(url)) {
      result.then(function () { window.setTimeout(refreshCartBadge, 300); }, function () {});
    }
    return result;
  };
})();

/* 2026-10-04: when a shopper picks a colour on a product page, (1) move that colour's photo into the big first slot (the product section only marked it active in the small grid, so the big photo never changed), (2) hide photos that clearly belong to a DIFFERENT colour (matched on the photo file name, e.g. ...-navy-xs-m.png) so only the chosen colour's photos show, and (3) on phones/tablets slide the swipe carousel back to the first photo. If the chosen colour has no matching photos, nothing is hidden.
   18 Oct phone fix: on some phones the swipe carousel snapped back to the old colour's photo after the photos were re-ordered. Now, for about 1.2 seconds after a colour tap, snapping is switched off and the carousel is held on the first photo (released at once if the shopper touches it), then snapping is switched back on. */
(function () {
  'use strict';
  if (window.__swwGallerySwap) return;
  window.__swwGallerySwap = true;
  function colourFieldset() {
    var form = document.querySelector('.product__variant-form');
    if (!form) return null;
    var found = null;
    [].slice.call(form.querySelectorAll('.product__option')).forEach(function (f) {
      var l = f.querySelector('legend');
      if (!found && l && /colo/i.test(l.textContent)) found = f;
    });
    return found;
  }
  function tok(v) { return '-' + String(v).toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '') + '-'; }
  function fileTok(item) {
    var im = item.querySelector('img:not(.product__media-hover)');
    if (!im) return null;
    var f = im.src.split('?')[0].split('/').pop().replace(/\.[a-z0-9]+$/i, '');
    return '-' + f.toLowerCase().replace(/[^a-z0-9]+/g, '-') + '-';
  }
  function applyFilter() {
    var list = document.querySelector('.product__media-list');
    var fs = colourFieldset();
    if (!list || !fs) return;
    var radios = [].slice.call(fs.querySelectorAll('input[type="radio"]'));
    var sel = null;
    radios.forEach(function (r) { if (r.checked) sel = r; });
    if (!sel) return;
    var items = [].slice.call(list.children);
    var sets = items.map(function (it) {
      var n = fileTok(it);
      if (!n) return null;
      var s = [];
      radios.forEach(function (r) { if (n.indexOf(tok(r.value)) > -1) s.push(r.value); });
      return s;
    });
    var matches = 0;
    sets.forEach(function (s) { if (s && s.indexOf(sel.value) > -1) matches++; });
    items.forEach(function (it, i) {
      var s = sets[i];
      var hide = matches >= 1 && s && s.length > 0 && s.indexOf(sel.value) === -1;
      it.style.display = hide ? 'none' : '';
    });
    try { list.dispatchEvent(new Event('scroll')); } catch (e) {}
  }
  var holdTimers = [];
  var holdOff = null;
  function holdFirst(list) {
    holdTimers.forEach(function (t) { window.clearTimeout(t); });
    holdTimers = [];
    if (holdOff) { holdOff(); holdOff = null; }
    var held = true;
    var prevSnap = list.style.scrollSnapType;
    list.style.scrollSnapType = 'none';
    function release() {
      if (!held) return;
      held = false;
      list.removeEventListener('scroll', onScroll);
      list.removeEventListener('touchstart', release);
      list.removeEventListener('pointerdown', release);
      list.removeEventListener('wheel', release);
      list.style.scrollSnapType = prevSnap;
    }
    function onScroll() { if (held && list.scrollLeft > 2) { list.scrollLeft = 0; } }
    list.addEventListener('scroll', onScroll, { passive: true });
    list.addEventListener('touchstart', release, { passive: true });
    list.addEventListener('pointerdown', release, { passive: true });
    list.addEventListener('wheel', release, { passive: true });
    holdOff = release;
    function pin() { if (held) { list.scrollLeft = 0; } }
    pin();
    [60, 150, 300, 500, 800, 1100].forEach(function (ms) { holdTimers.push(window.setTimeout(pin, ms)); });
    holdTimers.push(window.setTimeout(function () { pin(); release(); list.scrollLeft = 0; }, 1250));
  }
  document.addEventListener('change', function (e) {
    var t = e.target;
    if (!t || !t.closest || !t.closest('.product__variant-form')) return;
    window.setTimeout(function () {
      var list = document.querySelector('.product__media-list');
      if (!list) return;
      var items = [].slice.call(list.children);
      items.forEach(function (el, i) {
        if (el.getAttribute('data-sww-i') === null) el.setAttribute('data-sww-i', i);
      });
      var active = list.querySelector('.product__media-item.is-active');
      if (!active) return;
      items.sort(function (a, b) {
        if (a === active) return -1;
        if (b === active) return 1;
        return (+a.getAttribute('data-sww-i')) - (+b.getAttribute('data-sww-i'));
      });
      items.forEach(function (el) { list.appendChild(el); });
      applyFilter();
      holdFirst(list);
    }, 50);
  });
  function init() { applyFilter(); window.setTimeout(applyFilter, 600); }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', init); } else { init(); }
})();

/* 2026-10-04: same as the live theme - old product descriptions still say "flat £6.99 to the rest of the world"; shipping is free worldwide now, so swap that sentence for "Everywhere else ships free too." */
(function () {
  'use strict';
  function fix() {
    var roots = document.querySelectorAll('.product__description, .product__info');
    for (var i = 0; i < roots.length; i++) {
      var w = document.createTreeWalker(roots[i], NodeFilter.SHOW_TEXT, null, false), n, list = [];
      while ((n = w.nextNode())) { list.push(n); }
      list.forEach(function (t) {
        if (t.nodeValue.indexOf('6.99') === -1) { return; }
        t.nodeValue = t.nodeValue.replace(/(^|[.!?][ ]+)([^.!?]*£[ ]?6[.]99[^.!?]*[.!?]?)/g, function (m, p, s) {
          if (/else|rest of|world|ship|deliver|flat|postage/i.test(s)) { return p + 'Everywhere else ships free too.'; }
          return m;
        });
      });
    }
  }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', fix); } else { fix(); }
})();

/* 2026-10-04: picking a colour used to fling the page back up to the big photo (the product section scrolled to it), so shoppers had to scroll down again for the next choice. Now the page stays put and a photo of the chosen colour sits beside the colour choices instead (desktop; on phones the swipe carousel sits right above the choices); tapping it opens it full size. Tapping any main product photo also opens it full size (pinch-zoom works on it); the enlarged picture is loaded at 1600px wide so it stays sharp.
   18 Oct fix: the small "Tap to enlarge" photo sometimes stayed on the old colour after a real tap (the theme swaps the form, so the old listener was lost). It now listens on the whole page, reads the chosen option's own photo, re-checks a few times, and also follows any change to the active photo. */
(function () {
  'use strict';
  if (window.__swwColourPreview) return;
  window.__swwColourPreview = true;
  var orig = Element.prototype.scrollIntoView;
  Element.prototype.scrollIntoView = function () {
    try { if (this.classList && this.classList.contains('product__media-item')) return; } catch (e) {}
    return orig.apply(this, arguments);
  };
  function imgOf(item) {
    var im = item && item.querySelector('img:not(.product__media-hover)');
    return im ? (im.currentSrc || im.src) : '';
  }
  function openBig(src) {
    var o = document.createElement('div');
    o.className = 'sww-lightbox';
    o.setAttribute('role', 'dialog');
    o.innerHTML = '<button type="button" class="sww-lightbox__close" aria-label="Close">×</button><img alt="">';
    o.querySelector('img').src = String(src).replace(/([?&]width=)\d+/, '$11600');
    function close() { if (o.parentNode) o.parentNode.removeChild(o); document.removeEventListener('keydown', onKey); }
    function onKey(e) { if (e.key === 'Escape') close(); }
    o.addEventListener('click', close);
    document.addEventListener('keydown', onKey);
    document.body.appendChild(o);
  }
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    var item = t.closest('.product__media-item');
    if (!item || !item.closest('.product__media-list')) return;
    if (t.closest('video, iframe, a, button')) return;
    var src = imgOf(item);
    if (src) openBig(src);
  });
  function setup() {
    var form = document.querySelector('.product__variant-form');
    if (!form) return;
    var fs = null;
    [].slice.call(form.querySelectorAll('.product__option')).forEach(function (f) {
      var l = f.querySelector('legend');
      if (!fs && l && /colo/i.test(l.textContent)) fs = f;
    });
    if (!fs) return;
    var box = document.createElement('button');
    box.type = 'button';
    box.className = 'sww-colour-preview';
    box.setAttribute('aria-label', 'View this colour full size');
    var img = document.createElement('img');
    img.alt = '';
    var cap = document.createElement('span');
    cap.textContent = 'Tap to enlarge';
    box.appendChild(img);
    box.appendChild(cap);
    box.addEventListener('click', function () { if (img.src) openBig(img.src); });
    fs.insertBefore(box, fs.firstChild.nextSibling || null);
    function fromVariant() {
      try {
        var data = JSON.parse(document.querySelector('script[data-variants-json]').textContent);
        var idEl = document.querySelector('input[data-product-variant-id]');
        var id = idEl ? idEl.value : '';
        if (!id) { var m = location.search.match(/[?&]variant=(\d+)/); if (m) id = m[1]; }
        for (var i = 0; i < data.length; i++) {
          if (String(data[i].id) === String(id) && data[i].media) {
            return imgOf(document.querySelector('.product__media-item[data-media-id="' + data[i].media + '"]'));
          }
        }
      } catch (e) {}
      return '';
    }
    function show(src) { if (src) { if (img.src !== src) img.src = src; box.style.display = 'block'; } }
    function refresh() { show(fromVariant() || imgOf(document.querySelector('.product__media-item.is-active'))); }
    refresh();
    if (!img.src) show(imgOf(document.querySelector('.product__media-item')));
    document.addEventListener('change', function (e) {
      var t = e.target;
      if (!t || !t.closest || !t.closest('.product__variant-form, .product__info')) return;
      [120, 400, 900, 1600].forEach(function (ms) { window.setTimeout(refresh, ms); });
    });
    var list = document.querySelector('.product__media-list');
    var tmr;
    if (list && window.MutationObserver) {
      new MutationObserver(function () { clearTimeout(tmr); tmr = setTimeout(refresh, 80); })
        .observe(list, { attributes: true, subtree: true, attributeFilter: ['class'] });
    }
  }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', setup); } else { setup(); }
})();

/* 2026-10-04: phones/tablets - photos are a swipe carousel (CSS), this adds the "3 / 12" counter on top of it (counts only the photos currently shown). */
(function () {
  'use strict';
  if (window.__swwCarouselCount) return;
  window.__swwCarouselCount = true;
  function setup() {
    var list = document.querySelector('.product__media-list');
    if (!list || list.children.length < 2) return;
    var wrap = list.parentNode;
    var c = document.createElement('div');
    c.className = 'sww-carousel-count';
    c.setAttribute('aria-hidden', 'true');
    wrap.appendChild(c);
    function upd() {
      var total = [].filter.call(list.children, function (x) { return x.style.display !== 'none'; }).length;
      var w = list.clientWidth || 1;
      var i = Math.min(total, Math.round(list.scrollLeft / w) + 1);
      c.textContent = i + ' / ' + total;
    }
    list.addEventListener('scroll', upd, { passive: true });
    window.addEventListener('resize', upd);
    new MutationObserver(upd).observe(list, { childList: true });
    upd();
  }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', setup); } else { setup(); }
})();

/* 2026-10-04: phones/tablets - the Vitals "Buy 1 / Buy 2" bundle box sits above the colour choices and pushes them ~300px down the page. Move the colour/size choices up to sit right under the price (the bundle box still follows and stays in sync). Tested: picking a colour still updates the bundle box and the Add to cart variant. */
(function () {
  'use strict';
  if (window.__swwPickerUp) return;
  window.__swwPickerUp = true;
  function move() {
    if (!window.matchMedia || !window.matchMedia('(max-width: 989px)').matches) return;
    var price = document.querySelector('.product__info .product__price');
    var form = document.querySelector('.product__info .product__variant-form');
    if (!price || !form || price.nextElementSibling === form) return;
    price.insertAdjacentElement('afterend', form);
  }
  function run() { move(); window.setTimeout(move, 1500); window.setTimeout(move, 4000); }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', run); } else { run(); }
})();
